import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import BlockLoader from "../BlockLoader";
import TaskInfoTags from "../TaskInfoTags";

export interface TaskInfo {
    name: string;
    value: string | number;
    order: number;
}

interface TaskWrapProps {
    title: string;
    description: string;
    isLoading: boolean;
    isSelected: boolean;
    isClassFull: boolean;
    isNotEnglish: boolean;
    isTaskCompleted: boolean;
    taskInfo: TaskInfo[];
    language: string;
    isClassRanking?: boolean;
    isFirstOption?: boolean;
    isSecondOption?: boolean;
    changeOrder?: (e: any, order: number) => void;
    hasFirstOptionSelected?: boolean;
    hasSecondOptionSelected?: boolean;
    error?: string | null;
    isCancellationDisabled?: boolean;
}

const TaskWrap = ({
    title,
    description,
    isLoading,
    isSelected,
    isClassFull,
    isTaskCompleted,
    isNotEnglish,
    taskInfo,
    language,
    changeOrder,
    isClassRanking = false,
    isFirstOption = false,
    isSecondOption = false,
    hasFirstOptionSelected = false,
    hasSecondOptionSelected = false,
    error = null,
    isCancellationDisabled = false,
}: TaskWrapProps) => {
    const [taskTags, setTaskTags] = useState<string[]>([]);

    useEffect(() => {
        const newTaskTags = [];
        if (isSelected) newTaskTags.push("Selected");
        if (isClassFull) newTaskTags.push("Full");
        if (isCancellationDisabled) newTaskTags.push("Locked");
        setTaskTags(newTaskTags);
    }, [isSelected, isClassFull, isCancellationDisabled]);

    const getTrackContainerClass = () => {
        let className = "";
        if(isTaskCompleted) className += ` ${styles.completed}`;
        if (isSelected) className += ` ${styles.selected}`;
        else if (isClassFull) className += ` ${styles.full}`;
        if (error) className += ` ${styles.error}`;
        return className;
    };

    return (
        <div className={`${styles.container} ${getTrackContainerClass()}`}>
            <div className={styles.tags} style={{ marginBottom: taskTags.length ? "" : "16px" }}>
                {taskTags.map((tag) => (
                    <div key={tag} className={`${styles.tag} ${styles[tag]} ${isClassFull ? styles.isFull : ""} ${isNotEnglish ? styles.notEnglish : ""}`}>
                        {tag}
                    </div>
                ))}
            </div>
            <div className={`${styles.details} ${isNotEnglish ? styles.notEnglish : ""}`}>
                <TaskInfoTags
                    taskInfo={taskInfo}
                    language={language}
                    isClassFull={isClassFull && !isSelected}
                />
                <div className={styles.name}>{title}</div>
                <div className={styles.description}>{description}</div>
                {error && <div className={styles.errorMessage}>{error}</div>}
                {isClassRanking && (
                    <div className={styles.options}>
                        <button 
                            className={`${isFirstOption ? styles.selected : ""} ${isLoading ? styles.disabled : ""}`} 
                            onClick={(e)=> changeOrder(e, 1)}
                            disabled={isLoading}
                        >
                            <strong>1st</strong> choice
                        </button>
                        {hasFirstOptionSelected && hasSecondOptionSelected && (
                            <button 
                                className={`${isSecondOption ? styles.selected : ""} ${isLoading ? styles.disabled : ""}`} 
                                onClick={(e)=> changeOrder(e, 2)}
                                disabled={isLoading}
                            >
                                <strong>2nd</strong> choice
                            </button>
                        )}
                    </div>
                )}
                <BlockLoader isLoading={isLoading} />   
            </div>
        </div>
    );
};

export default TaskWrap;